import { render } from "./BaseImg.vue?vue&type=template&id=b07b02f8"
import script from "./BaseImg.vue?vue&type=script&lang=js"
export * from "./BaseImg.vue?vue&type=script&lang=js"

import "./BaseImg.vue?vue&type=style&index=0&id=b07b02f8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__